module.exports = "<!--Main Content Container-->\n<div>\n    <router-outlet></router-outlet>\n    <simple-notifications [options]=\"options\"></simple-notifications>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 892
// module chunks = 0